export function puCurrency(value: number, locale: string, options?: string) {
  if (typeof value !== 'number') {
    return ''
  }
  const config: Intl.NumberFormatOptions = {
    style: 'currency',
    currency: getCurrencyFromOptions(options || ''),
    currencyDisplay: 'symbol',
  }

  const minimumFractionDigits = getMinFractionDigitsFromOptions(options || '')
  if (minimumFractionDigits >= 0) {
    config.minimumFractionDigits = minimumFractionDigits
  }

  const maximumFractionDigits = getMaxFractionDigitsFromOptions(options || '')
  // This will be false if trying to set maximumFractionDigits to 0
  if (maximumFractionDigits) {
    config.maximumFractionDigits = maximumFractionDigits
  }
  return new Intl.NumberFormat(locale, config).format(value)
  function getCurrencyFromOptions(options: string): string {
    const currency = getFromOptions(options, 'currency')
    return currency || 'GBP'
  }

  function getMinFractionDigitsFromOptions(options: string): number {
    const minimumFractionDigits = getFromOptions(
      options,
      'minimumFractionDigits',
    )
    return minimumFractionDigits ? parseInt(minimumFractionDigits) : 2
  }

  function getMaxFractionDigitsFromOptions(options: string) {
    const maximumFractionDigits = getFromOptions(
      options,
      'maximumFractionDigits',
    )
    return maximumFractionDigits ? parseInt(maximumFractionDigits) : undefined
  }

  function getFromOptions(options: string, optionToFind: string): string {
    if (!options) {
      return ''
    }
    const option = options.split(' ').find((o) => o.startsWith(optionToFind))
    return option ? option.split(':')[1] : ''
  }
}
